import { useShop } from "hooks/firestore/simple/useShop"

export default function OpeningHoursSection() {
  const shop = useShop()

  if (!shop) return

  if (!shop.landingpage?.openingHours) return

  // Format opening hours text to display multiple time slots on separate lines
  const formatHours = (hoursText: string | undefined) => {
    if (!hoursText) return "–"

    // Split by "&" if it exists to separate different time slots
    return hoursText.split("&").map((slot, index) => (
      <div key={index} className="tw-whitespace-nowrap">
        {slot.trim()}
      </div>
    ))
  }

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-24">
      <h2 className="tw-mb-8">Öffnungszeiten</h2>
      <div className="tw-grid tw-grid-cols-[auto_1fr] tw-gap-x-6 tw-gap-y-2 tw-max-w-md">
        <div className="tw-font-bold">Montag:</div>
        <div>{formatHours(shop.landingpage.openingHours.monday || "")}</div>

        <div className="tw-font-bold">Dienstag:</div>
        <div>{formatHours(shop.landingpage.openingHours.tuesday)}</div>

        <div className="tw-font-bold">Mittwoch:</div>
        <div>{formatHours(shop.landingpage.openingHours.wednesday)}</div>

        <div className="tw-font-bold">Donnerstag:</div>
        <div>{formatHours(shop.landingpage.openingHours.thursday)}</div>

        <div className="tw-font-bold">Freitag:</div>
        <div>{formatHours(shop.landingpage.openingHours.friday)}</div>

        <div className="tw-font-bold">Samstag:</div>
        <div>{formatHours(shop.landingpage.openingHours.saturday)}</div>

        <div className="tw-font-bold">Sonntag:</div>
        <div>{formatHours(shop.landingpage.openingHours.sunday)}</div>
      </div>
    </div>
  )
}
